import styles from "./table.module.css"

const SummaryTable = ({ headers, rows }: { headers: any[], rows: any[] }) => {
    return (
        <table className={styles.tableStyles}>
            <thead>
                <tr>
                    {headers.map((header, index) => (
                        <th key={index} className={styles.headerStyles}>{header.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={rowIndex} className={styles.rowStyles}>
                        {headers.map((header, index) => (
                            <td key={index} className={styles.cellStyles}>
                                {row[header.id]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export { SummaryTable };